import React, {useEffect, useState} from 'react';
import {MapContainer, TileLayer, Marker, Popup, Polyline} from 'react-leaflet';
import L from 'leaflet';
import gromitImage from './gromit.png';
import feathersImage from './feathers_mcgraw.png';
import {useApiSubmit} from "../../api_client";
import './gromit_unleashed.css';

// Fix for default markers in React Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const gromitIcon = L.icon({
    iconUrl: gromitImage,
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -16],
    shadowSize: [41, 41],
    shadowAnchor: [12, 41]
});

const feathersMcgrawIcon = L.icon({
    iconUrl: feathersImage,
    iconSize: [26, 52],
    iconAnchor: [16, 16],
    popupAnchor: [0, -16],
    shadowSize: [41, 41],
    shadowAnchor: [12, 41]
});

const GROMIT_LOCATIONS = [
    {"name": "Aardman Animations, Gas Ferry Road", "latitude": 51.447408, "longitude": -2.608124},
    {"name": "Aerospace Bristol", "latitude": 51.523535, "longitude": -2.578349},
    {"name": "Ashton Court, Long Ashton", "latitude": 51.440833, "longitude": -2.643056},
    {"name": "Ashton Gate Stadium, Ashton Road", "latitude": 51.440167, "longitude": -2.620556},
    {"name": "Beauford Arms, Hawkesbury Upton", "latitude": 51.581318, "longitude": -2.322014},
    {"name": "Brabazon, Patchway", "latitude": 51.521565, "longitude": -2.581519},
    {"name": "Bristol Bus & Coach Station, Marlborough Street", "latitude": 51.459456, "longitude": -2.592501},
    {"name": "Bristol Children's Hospital, Upper Maudlin Street", "latitude": 51.457739, "longitude": -2.596875},
    {"name": "Bristol Museum and Art Gallery, Queens Road", "latitude": 51.456079, "longitude": -2.605267},
    {"name": "Broadmead", "latitude": 51.458126, "longitude": -2.587703},
    {"name": "Cabot Circus", "latitude": 51.458557, "longitude": -2.584978},
    {"name": "Cheddar Gorge and Caves, Cheddar", "latitude": 51.285000, "longitude": -2.768333},
    {"name": "Clifton Observatory, Clifton", "latitude": 51.456540, "longitude": -2.626522},
    {"name": "Clifton Suspension Bridge", "latitude": 51.455868, "longitude": -2.625485},
    {"name": "College Green", "latitude": 51.452367, "longitude": -2.601013},
    {"name": "Cribbs Mall", "latitude": 51.524761, "longitude": -2.596376},
    {"name": "CrossFit Henleaze, Henleaze Road", "latitude": 51.485473, "longitude": -2.611755},
    {"name": "Flaxpits Lane, Winterbourne", "latitude": 51.522190, "longitude": -2.504589},
    {"name": "Freemasons Hall, Park Street", "latitude": 51.453693, "longitude": -2.601812},
    {"name": "Gardiner Haskins Interiors, Straight Street", "latitude": 51.454221, "longitude": -2.581626},
    {"name": "Hargreaves Lansdown, Anchor Road", "latitude": 51.450433, "longitude": -2.603169},
    {"name": "IKEA Bristol, Eastgate Shopping Centre", "latitude": 51.472083, "longitude": -2.565825},
    {"name": "Kingswood Park, High Street, Kingswood", "latitude": 51.461797, "longitude": -2.501789},
    {"name": "M Shed, Princes Wharf, Wapping Road", "latitude": 51.447473, "longitude": -2.598217},
    {"name": "Narrow Quay", "latitude": 51.450304, "longitude": -2.597384},
    {"name": "Noah's Ark Zoo Farm, Wraxall", "latitude": 51.454815, "longitude": -2.742266},
    {"name": "North Street, Southville", "latitude": 51.440196, "longitude": -2.610459},
    {"name": "Puxton Park, Hewish", "latitude": 51.361537, "longitude": -2.870707},
    {"name": "Quakers Friars, Broadmead", "latitude": 51.457096, "longitude": -2.587351},
    {"name": "St Mary Centre, Thornbury", "latitude": 51.608367, "longitude": -2.524854},
    {"name": "St Mary Redcliffe, Redcliffe", "latitude": 51.4483, "longitude": -2.5896},
    {"name": "St Nicholas Market, The Corn Exchange", "latitude": 51.454474, "longitude": -2.592450},
    {"name": "Temple Meads Station", "latitude": 51.4499, "longitude": -2.5808},
    {"name": "The Kendleshire, Coalpit Heath", "latitude": 51.511207, "longitude": -2.469398},
    {"name": "The New Inn, Blagdon", "latitude": 51.327483, "longitude": -2.711635},
    {"name": "The Rose & Crown, Pucklechurch", "latitude": 51.490155, "longitude": -2.439655},
    {"name": "The Wave, Easter Compton", "latitude": 51.545260, "longitude": -2.605414},
    {"name": "Thunderbolt Square", "latitude": 51.451411, "longitude": -2.595864},
    {"name": "TOUT'S, Main Road, Cleeve", "latitude": 51.386853, "longitude": -2.782627},
    {"name": "Underfall Yard, Cumberland Road", "latitude": 51.446818, "longitude": -2.617985},
    {"name": "Valentine's Bridge, Temple Quay", "latitude": 51.450688, "longitude": -2.582981},
    {"name": "Victoria Park, Windmill Hill", "latitude": 51.440585, "longitude": -2.587705},
    {"name": "Victoria Rooms, Queens Road", "latitude": 51.458143, "longitude": -2.609361},
    {"name": "Victoria Square, Clifton Village", "latitude": 51.455413, "longitude": -2.616252},
    {"name": "Wai Yee Hong, Eastgate Road", "latitude": 51.472830, "longitude": -2.569406},
    {"name": "Warmley Waiting Room, Bristol and Bath Railway Path", "latitude": 51.460126, "longitude": -2.475024},
    {"name": "We The Curious, One Millennium Square", "latitude": 51.450345, "longitude": -2.599821},
    {"name": "West Country Water Park, Frampton Cotterell", "latitude": 51.541512, "longitude": -2.536600},
    {"name": "Whiteladies Road, Clifton", "latitude": 51.464336, "longitude": -2.609589},
    {"name": "Willow Brook, Bradley Stoke", "latitude": 51.535904, "longitude": -2.549244},
    {"name": "WWT Slimbridge, Gloucestershire", "latitude": 51.741154, "longitude": -2.403174}
];

const LoadingSpinner = () => {
    const [messageIndex, setMessageIndex] = useState(0);

    const messages = [
        "this will take a while",
        "gromit's calculating the best route",
        "wallace is making tea while we wait",
        "checking for cheese shops along the way",
        "feathers mcgraw isn't involved, we promise",
        "the techno trousers are working on it",
        "almost done! just like a good wensleydale",
        "crackers! this is taking longer than expected",
        "grand day for route planning, isn't it?",
        "preston's helping with the calculations"
    ];
    messages.sort(() => Math.random() - 0.5);

    useEffect(() => {
        const interval = setInterval(() => {
            setMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="spinner-container">
            <div className="spinner-container-inner">
                <div className="spinner" />
                <div className="spinner-text">Loading.....{messages[messageIndex]}</div>
            </div>
        </div>
    );
};


const GromitMarker = ({index, name, location, onMarkerClick, icon}) => {
    return (
        <Marker
            key={index}
            position={[location.latitude, location.longitude]}
            icon={icon}
            eventHandlers={{
                click: (e) => {
                    onMarkerClick(name, location.latitude, location.longitude);
                }
            }}
        >
            <Popup>
                <div style={{ color: '#333', fontWeight: 'bold' }}>
                    {name}
                </div>
            </Popup>
        </Marker>
    )
}


const Stage = ({polyline, index, distance}) => {
    if (!polyline || !Array.isArray(polyline) || polyline.length === 0) return null;

    const positions = polyline.map(coord => [coord[1], coord[0]]);

    console.log('positions:', positions);

    if (!positions || positions.length === 0) return null;

    return (
        <Polyline
            positions={positions}
            color="pink"
            weight={3}
            opacity={0.8}
        />
    )
}

export const GromitUnleashed = () => {
    const { submitData, loading, error: apiError } = useApiSubmit();
    const [selectedGromits, setSelectedGromits] = useState([]);
    const [route, setRoute] = useState(null)
    const position = [51.461, -2.6084];  // Latitude and Longitude for the map center

    const onMarkerClick = (name, latitude, longitude) => {
        const newSelectedGromits = [...selectedGromits];
        newSelectedGromits.push({name, latitude, longitude});
        setSelectedGromits(newSelectedGromits);
        console.log(selectedGromits);
    }

    const selectIcon = (name) => {
        if (selectedGromits.some(gromit => gromit.name === name)) {
            return feathersMcgrawIcon;
        } else {
            return gromitIcon;
        }
    }

    const submitGromits = async () => {
        console.log(selectedGromits);
        // Submit login data to the API
        if (selectedGromits.length > 100) {
            alert("*Gromit gives Wallace a stern look* Woof woof! The machinery can currently only handle 5 locations, Wallace - we don't want another Wrong Trousers situation! *adjusts glasses nervously*")
        }
        else {
            const result = await submitData('/api/gromit_unleashed/best_route', {
                "locations": selectedGromits
            });
            console.log("Route planning done: ", result);
            setRoute(result)
            console.log(route);
        }
    }

    const reset = () => {
        setSelectedGromits([]);
        setRoute(null);
    }

    return (
        <div className="gromit_unleashed" style={{ position: 'relative', height: '100vh', width: '100%' }}>
            <MapContainer
                center={position}
                zoom={11}
                style={{ height: "100vh", width: "100%" }}
                preferCanvas={true}
            >
                <TileLayer
                    url="https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png"
                    minZoom={5}
                    maxZoom={17}
                    attribution='&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                {route !== null && route.stages.map((stage, index) => (
                    <Stage key={index} polyline={stage.polyline} index={stage.index} distance={stage.distance}/>
                ))}
                {GROMIT_LOCATIONS.map((location, index) => (
                    <GromitMarker key={index} index={index} name={location.name} location={location} onMarkerClick={onMarkerClick} icon={selectIcon(location.name)}/>
                ))}
            </MapContainer>
            <button
                className="nav_button"
                style={{
                    position: 'absolute',
                    backgroundColor: 'rgb(255, 100, 100)',
                    top: '10px',
                    right: '120px',
                    zIndex: 1000,
                    opacity: selectedGromits.length > 0 ? 1.0 : 0.5
                }}
                onClick={() => reset()}
            >
                Reset
            </button>
            <button
                className="nav_button"
                style={{
                    position: 'absolute',
                    backgroundColor: 'rgb(100, 180, 100)',
                    top: '10px',
                    right: '10px',
                    zIndex: 999,
                    opacity: selectedGromits.length > 0 ? 1.0 : 0.5
                }}
                onClick={() => submitGromits()}
            >
                Submit
            </button>
            {loading && <LoadingSpinner />}
            {route !== null && <div
                style={{
                    position: 'absolute',
                    backgroundColor: '#b3b8bd',
                    top: '65px',
                    right: '10px',
                    borderRadius: '4px',
                    zIndex: 999,
                    padding: '5px 10px 5px 10px',
                    width: '174px',
                    height: '70px',
                }}>
                <p><b>Total Length:</b> {route.length_km}km</p>
                <p><b>Total Stops:</b> {Object.keys(route.stages).length + 1}</p>
            </div>}
        </div>
    )
};
